/**
 * Created by Fernando Torres on 01/02/2018.
 */
import DashboardView from '@/views/app/dashboard/dashboard.view'

export default [
  {
    path: 'dashboard',
    name: 'dashboard',
    component: DashboardView
  }
]



// WEBPACK FOOTER //
// ./src/router/app/dashboard/index.js